import { IncidentItem } from '@/server/services/GoogleBigQuery/BigQueryIncidentsClient.types';

export const ORG_ID_POC_DEMO = 'org_xXfBz4Eh4GyNoZbP';
const ALARM_SOURCE = '997';
const ALARM_TYPE = 'Fire';

export const isPocDemoOrgId = (orgId: string) => orgId === ORG_ID_POC_DEMO;
export const isPocAlarmEvent = (incident: Pick<IncidentItem, 'DataSource'>) => incident.DataSource === ALARM_SOURCE;
export const isPocAlarmIncidentTypeName = (incident: Pick<IncidentItem, 'IncidentTypeName'>) =>
  incident.IncidentTypeName === ALARM_TYPE;
